<h2 mat-dialog-title>Periodontograma — diente {{ fdi }} ({{ nombreFdi }})</h2>

<mat-dialog-content class="perio-popover">
  <div class="por-diente">
    <label class="check">
      <input type="checkbox" [(ngModel)]="entry.presente" /> Diente presente
    </label>
    <label>
      Movilidad
      <select [(ngModel)]="entry.movilidad">
        <option [ngValue]="null">—</option>
        <option *ngFor="let m of movilidades" [ngValue]="m">{{ m }}</option>
      </select>
    </label>
    <label>
      Furca
      <select [(ngModel)]="entry.furca">
        <option [ngValue]="null">—</option>
        <option *ngFor="let f of furcas" [ngValue]="f">{{ f }}</option>
      </select>
    </label>
    <label>
      Pronóstico
      <select [(ngModel)]="entry.pronostico">
        <option [ngValue]="null">—</option>
        <option *ngFor="let p of pronosticos" [ngValue]="p.valor">{{ p.label }}</option>
      </select>
    </label>
    <label class="check">
      <input type="checkbox" [(ngModel)]="entry.implante" /> Implante
    </label>
  </div>

  <div class="cara-block" *ngFor="let cara of caras">
    <h3>{{ tituloCara(cara) }}</h3>
    <table class="sitios-tabla">
      <tr>
        <th></th>
        <th *ngFor="let s of sitios">{{ s }}</th>
      </tr>
      <tr>
        <td>Sondaje (mm)</td>
        <td *ngFor="let s of sitios; let i = index">
          <input type="number" step="1" min="0" max="15" [(ngModel)]="entry[cara].sondaje[i]" />
        </td>
      </tr>
      <tr>
        <td>Margen (mm)</td>
        <td *ngFor="let s of sitios; let i = index">
          <input type="number" step="1" min="-10" max="15" [(ngModel)]="entry[cara].margen[i]" />
        </td>
      </tr>
      <tr>
        <td>Sangrado</td>
        <td *ngFor="let s of sitios; let i = index">
          <input type="checkbox" [(ngModel)]="entry[cara].sangrado[i]" />
        </td>
      </tr>
      <tr>
        <td>Supuración</td>
        <td *ngFor="let s of sitios; let i = index">
          <input type="checkbox" [(ngModel)]="entry[cara].supuracion[i]" />
        </td>
      </tr>
      <tr>
        <td>Placa</td>
        <td *ngFor="let s of sitios; let i = index">
          <input type="checkbox" [(ngModel)]="entry[cara].placa[i]" />
        </td>
      </tr>
      <tr>
        <td>Anchura encía (mm)</td>
        <td [attr.colspan]="sitios.length">
          <input type="number" step="1" min="0" max="15" [(ngModel)]="entry[cara].anchura" />
        </td>
      </tr>
    </table>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="limpiar()">Limpiar diente</button>
  <button mat-button (click)="cancelar()">Cancelar</button>
  <button mat-flat-button color="primary" (click)="guardar()">Guardar</button>
</mat-dialog-actions>
